import styled from 'styled-components';

export const SessionGroup = styled.div`
    label:first-child{
        margin-right: 10px;
    }
`;